import { NameDto } from 'api/Common/Types'

import { RestrictionDto } from './RestrictionDto'
import { WalletStates } from './WalletStates'

export interface WalletDto {
  id: string
  name: string
  client: {
    id: string
    name: string
  }
  currency: {
    id: CurrencyType
    name: string
  }
  walletType: {
    id: number
    name: 'ETD' | 'FX/CFD' | 'IB FX/CFD'
    tickmillProduct?: NameDto
  }
  tradingAccounts: WalletTradingAccount[]
  walletState: WalletStates
  balance: number
  restrictions: RestrictionDto[]
  reserved: number
  bonusReserved: number
  pending: number
  createdDate: string
  expanded?: boolean
}

export enum WalletType {
  ETD = 2,
  FXCFD = 1,
  IB_FXCFD = 10,
  PAYMENT_AGENT = 100,
}

export type CurrencyType = 'USD' | 'GBP' | 'EUR' | 'PLN' | 'CHF' | 'ZAR' | 'MAD' | 'N/A'
export type DragonPhoenixCurrencyType = 'IDR'
export type PHPCurrencyType = 'PHP'

export interface WalletTradingAccountCampaign {
  id: string
  type: {
    id: number
    name: string
  }
  calculationType: {
    id: number
    name: string
  }
  name: string
  key: string
  minDepositAmount: number
  defaultCurrencyId: string
  status: {
    id: number
    name: string
  }
  tradingAccountCurrencyMinDepositAmount: number
  automaticClosure: boolean
}

export interface WalletTradingAccountAccountGroup {
  id: string
  name: string
  currency: {
    id: string
    name: string
  }
  restrictions: any[]
  classificationType: {
    id: number
    name: string
  }
  tickmillCompany: {
    id: number
    name: string
  }
  bookType: {
    id: number
    name: string
  }
}

export interface WalletTradingAccountServer {
  publicName: string
  id: string
  name: string
}

export interface WalletTradingAccount {
  id: string
  name: string
  client: NameDto<string>
  introducingBroker: any
  accountGroup: WalletTradingAccountAccountGroup
  wallet: NameDto<string>
  accountType: NameDto
  accountGroupType: NameDto
  currency: NameDto<string>
  isTradingViewConnected: boolean | null
  status: NameDto
  country: NameDto<string>
  tickmillCompany: NameDto
  leverageType: NameDto
  platformType: {
    id: number
    name: string
    dynamicLeverage: boolean
  }
  parentPlatformType: any
  server: WalletTradingAccountServer
  restrictions: string[]
  businessRules: string[]
  isSwapFree: boolean
  balance: number
  equity: number
  createdDate: string
  updatedDate: string
  externalId: string | null
  campaigns: WalletTradingAccountCampaign[]
}

export enum WalletKey {
  id = 'id',
  name = 'name',
  client = 'client.name',
  walletType = 'walletType.name',
  walletState = 'walletState.name',
  currency = 'currency.id',
  balance = 'balance',
  reserved = 'reserved',
  tradingAccounts = 'tradingAccounts',
  companyName = 'company.name',
  createdDate = 'createdDate',
}

export enum WalletFilterKey {
  name = 'Name',
  client = 'Client.Name',
  walletType = 'WalletTypeId',
  walletState = 'WalletStateId',
  currency = 'CurrencyId',
  balance = 'Balance',
  reserved = 'Reserved',
  tradingAccounts = 'TradingAccounts',
  company = 'TickmillCompanyId',
  createdDate = 'Created',
  isInternalTestAccount = 'IsInternalTestAccount',
}
